<template>
  <div class="d-flex flex-column gap-20">
    <strong class="font-size-125">{{ 'CONTACT US' | trans }}</strong>
    <div class="d-flex flex-column gap-10">
      <TextInput
        class="press-text-input"
        type="text"
        name="full_name"
        :placeholder="'Full Name' | trans"
        v-model="fullName"
        :disabled="false"
        autocomplete="off"
        borderClass="border-5"
      ></TextInput>
      <TextInput
        class="press-text-input"
        type="text"
        name="emial"
        :placeholder="'E-Mail' | trans"
        v-model="email"
        :disabled="false"
        autocomplete="off"
        borderClass="border-5"
      ></TextInput>
      <TextInput
        class="press-text-input"
        type="text"
        name="url_channel"
        :placeholder="'URL/Channel' | trans"
        v-model="urlOrChannel"
        :disabled="false"
        autocomplete="off"
        borderClass="border-5"
      ></TextInput>
      <TextArea
        v-model="message"
        name="message"
        :skipFocus="true"
        :hideLength="true"
        :rows="'4'"
        :placeholder="'additional notes' | trans"
        class="press-text-area"
        type="text"
      ></TextArea>
      <button type="button" class="btn btn-lg submit-btn send-btn" @click="submitContactUs">
        <strong class="text-uppercase">{{ "Send"|trans({}, 'general') }}</strong>
        <i class="fa fa-arrow-right lh-inherit"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { apiRequestManager } from '../../../../lib-sat/api/api-request-manager';
import { csrfManager } from '../../../../lib-sat/csrf/csrf-manager';
import { pageNotification } from '../../../helper/notify';
import DataStatus from './mixins/DataStatus';
import TransFilter from './mixins/TransFilter';
import { translate } from '../../../helper/translate';
import TextInput from "./form/TextInput";
import TextArea from "./form/TextArea";
import { globalLogger } from '../../../helper/global-logger';

export default {
    name: 'PressContactUs',
    components: { TextInput, TextArea },
    mixins: [DataStatus, TransFilter],
    computed: {},
    methods: {
      submitContactUs() {
        const data = {
          name: this.fullName,
          email: this.email,
          url: this.urlOrChannel,
          message: this.message,
          type: 'press',
        };

        this.setStatusLoading();

        csrfManager
          .getCsrfContactUs()
          .then((token) => {
            data._csrf = token;

            return apiRequestManager.postWithCaptcha('api/contact-us', data);
          })
          .then(() => {
            const msg = translate('Thank you! We have received your request and will get back to you soon.');
            pageNotification.success(msg);
            globalLogger.log('press - contact us form - sending request success');
          })
          .catch(() => {
            pageNotification.showGenericErrorMessage();
            globalLogger.log('press - contact us form - sending request fail');
          })
          .finally(() => {
            this.setStatusDone();
          });
      }
    },
    data() {
        return {
            fullName: '',
            email: '',
            urlOrChannel: '',
            message: '',
        };
    },
};
</script>

<style lang="scss">
.press-text-input {
  input {
    padding: 5px 10px;
  }
}
.border-5 {
  border-radius: 5px;
  border: 1px solid #CBCBCB;
  background: #FBFBFB;
}
.press-text-area {
  > div {
    border-radius: 5px !important;
    border: 1px solid #CBCBCB !important;
    background: #FBFBFB;
  }
  textarea {
    padding: 10px;
  }
}
.send-btn {
  width: 111px;
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
